



















































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { ISpecRecord } from '@/store/types';
import { IPanelType, ITimeType, ITimeParsed } from '../types';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';
import TimePicker from './TimePicker.vue';

// 小组件的通用容器
@Component({
  components: { TooltipIcon, TimePicker },
})
export default class HomeWidgetCard extends Vue {
  @Prop() public title!: string;
  @Prop() public period!: ITimeType;    // 时间段
  @Prop() public startTime!: string;    // 开始时间(仅当时间段为'自定义'时有值)
  @Prop() public endTime!: string;      // 结束时间(仅当时间段为'自定义'时有值)
  @Prop() public items!: ISpecRecord[]; // 统计数据
  @Prop({ type: Boolean, default: true }) public showRefresh!: boolean; // 是否显示刷新按钮
  @Prop({ type: Boolean, default: false }) public showGoto!: boolean;   // 是否显示跳转按钮
  @Prop({ type: Boolean, default: false }) public onlyChart!: boolean;  // 仅显示图表
  @Prop({ type: Boolean, default: false }) public onlyTable!: boolean;  // 仅显示数据表格
  @Prop({ type: Boolean, default: false }) public disableTime!: boolean; // 是否禁用时间设置按钮

  @Ref('timePicker') public timePickerRef!: HTMLFormElement;

  public timer: any = null;
  public expanded = false;        // 是否折叠面板
  public disabledRefresh = false; // 是否禁止刷新数据
  public panelType: IPanelType = 'chart';
  public currentTime: ITimeParsed | null = null;

  // 折叠图标
  public get expandIcon() {
    return this.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down';
  }

  // 显示的时间
  public get showTime() {
    return this.currentTime?.showTime || '';
  }

  // 是否显示面板切换按钮
  public get showSwitchBtn() {
    if (this.onlyChart) {
      this.panelType = 'chart'
    } else if (this.onlyTable) {
      this.panelType = 'table'
    } else {
      this.panelType = this.panelType;
    }
    return !this.onlyChart && !this.onlyTable;

  }

  // 每2小时刷新一次数据
  public created() {
    this.timer = setInterval(() => {
      this.updateTime();  
    }, 1000 * 60 * 60 * 2);
  }

  public beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    this.currentTime = null;
  }

  // 更新时间
  public updateTime() {
    if (this.timePickerRef) {
      // 用来触发 onTimeChange
      this.timePickerRef.update();  
    }
  }

  // 时间设置更改时(初始化会触发)
  // emit: timeChange
  public onTimeChange(period: ITimeType, parsedTime: ITimeParsed) {
    this.currentTime = { ...parsedTime };
    this.$emit('timeChange', period, parsedTime);
  }

  // 展开/折叠面板
  // emit: expand
  public onExpand() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.updateTime();
    }
    this.$emit('expand', this.expanded, this.currentTime);
  }

  // 切换面板
  public onSwitch() {
    this.panelType = this.panelType === 'chart' ? 'table' : 'chart';
  }

  // 保存设置
  // emit: expand
  public onSave(period: ITimeType, parsedTime: ITimeParsed) {
    this.$emit('save', period, parsedTime);
  }
}
